import BuildingIcon from '@/components/Icons/BuildingIcon';
import HomeIcon from '@/components/Icons/HomeIcon';
import SquareFeetIcon from '@/components/Icons/SquareFeetIcon';
import type { Unit } from '@/domain/units';
import { getBathroomCount } from '@/utils/units';
import type { FC } from 'react';

interface PropertySpec {
  icon: FC<{ className?: string }>;
  label: string;
  value: string | number | undefined;
}

interface Props {
  unit: Unit;
}

const PropertySpecs: FC<Props> = ({ unit }) => {
  const SPECS: PropertySpec[] = [
    {
      icon: HomeIcon,
      label: 'Bedrooms',
      value: unit.bedroomCount,
    },
    {
      icon: BuildingIcon,
      label: 'Bathrooms',
      value: getBathroomCount({
        fullBathroomCount: unit.fullBathroomCount,
        halfBathroomCount: unit.halfBathroomCount,
        quarterBathroomCount: unit.quarterBathroomCount,
        threeQuarterBathroomCount: unit.threeQuarterBathroomCount,
      }),
    },
    {
      icon: SquareFeetIcon,
      label: 'Square Feet',
      value: unit.squareFeet,
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8 pt-8 border-t border-gray-200">
      {SPECS.map((spec) => (
        <div className="text-center" key={`property-spec-${spec.label}`}>
          <div className="flex items-center justify-center mb-2">
            <spec.icon className="w-8 h-8 text-primary-600" />
          </div>
          <div className="text-2xl font-bold text-gray-900">{spec.value}</div>
          <div className="text-sm text-gray-600">{spec.label}</div>
        </div>
      ))}
    </div>
  );
};

export default PropertySpecs;
